/* RESPONSIBLE TEAM: team-frontend-tech */
import { helper as buildHelper } from '@ember/component/helper';
import abbreviatedRelativeTimeAgoRawHelper from 'embercom/lib/abbreviated-relative-time-ago';

export { abbreviatedRelativeTimeAgoRawHelper };
export default buildHelper(function (params) {
  return abbreviatedRelativeTimeAgoRawHelper(params[0]);
});
